export default "/images/4b7ff626fdaa95758a40ed1f0ff1f8b0.avif";